import Common from "../../../Common"

const Channel = class extends Common {
	browse = (companyId: id) =>
		this.get(`/company/${companyId}/webchat/channel`)

	read = (companyId: id, channelId: id) =>
		this.get(`/company/${companyId}/webchat/channel/${channelId}`)

	update = (companyId: id, channelId: id, body = {})	=>
		this.post(`/company/${companyId}/webchat/channel/${channelId}`, body)

	create = (companyId: id, pbx_omnigroup_id: id) =>
		this.post(`/company/${companyId}/webchat/channel`, { pbx_omnigroup_id: pbx_omnigroup_id })

	deleteChannelInput = (companyId: id, channelId: id, inputId: id) =>
		this.doDelete(`/company/${companyId}/webchat/channel/${channelId}/${inputId}`)

	deleteChannel = (companyId: id, channelId: id) =>
		this.doDelete(`/company/${companyId}/webchat/channel/${channelId}`)
}

export default Channel
